var module = angular.module('octopusApp.projects');

import React from 'react';
import ReactCSSTransitionGroup from 'react/lib/ReactCSSTransitionGroup';
import {Button, Modal} from 'react-bootstrap';
import StepTemplateLogo from 'step_template_logo';
import showdown from 'showdown';
import xss from 'xss';

var markdownConverter = new showdown.Converter({
    simplifiedAutoLink: true,
    literalMidWordUnderscores:true
});

StepTemplate.propTypes = {
    template: React.PropTypes.object.isRequired,
    onAdditionRequested: React.PropTypes.func.isRequired,
    addButtonName: React.PropTypes.string,
    onInstallationRequested: React.PropTypes.func.isRequired,
    installButtonName: React.PropTypes.string,
    onUpdateRequested: React.PropTypes.func.isRequired,
    onDetailsRequested: React.PropTypes.func.isRequired,
    resolveLink: React.PropTypes.func.isRequired,
};

function StepTemplate(props){

    function getStatusText(template){
        if (template.IsBuiltIn) {
            return "by Octopus Deploy";
        }

        if (template.IsInstalled) {
            return "Installed";
        }

        return formatText(template.Author, 24);
    }

    function getStatusClass(template){
        if (template.IsBuiltIn) {
            return "template-status-built-in";
        }

        if (template.IsInstalled) {
            return "template-status-installed";
        }

        return "template-status-not-installed";
    }

    function getStatusLogo(template){
        if (template.IsBuiltIn) {
            return <i className="fontoctopus-octopus"></i>;
        }

        if (template.IsInstalled) {
            return <i className="fa fa-check-square-o" aria-hidden="true"></i>;
        }

        return <i className="fa fa-users" aria-hidden="true"></i>;
    }

    function getAddAction(template, onAdditionRequested, onInstallationRequested){
        if (template.IsInstalled) {
            return <button className="btn btn-success add" type="button" onClick={onAdditionRequested}>{props.addButtonName ? props.addButtonName : "Add step"}</button>;
        }
        return <button className="btn btn-success install" type="button" onClick={onInstallationRequested}>{props.installButtonName ? props.installButtonName : "Install and add step"}</button>;
    };

    function getAddActionDetailsClass(template){
        if (!template.IsInstalled) {
            return "add-action-details-not-installed";
        }

        if (template.HasUpdate) {
            return "add-action-details-update";
        }

        return "add-action-details-installed";
    };

    function ensureWholeWordsOnly(value)
    {
        var indexToTruncateAt = value.lastIndexOf(" ");
        if (indexToTruncateAt != -1)
        {
            value = value.substring(0, indexToTruncateAt).trim();
        }

        if (value[value.length - 1] === ".") value = value.substring(0, value.length - 1);

        return value;
    }

    // Truncates text and optionally converts markdown to HTML and sanitizes for XSS
    function formatText(value, maxCharacters, convertMarkdown) {
        value = (value || '').trim().replace(/\r?\n|\r/g, " ");

        if (convertMarkdown) {
            value = xss(markdownConverter.makeHtml(value));
        }

        return jQuery.truncate(value, {
            length: maxCharacters,
            words: true,
            noBreaks: true
        });
    }

    function getAddActionDetailsContent(template, onDetailsRequested, onUpdateRequested){
        if (!template.IsInstalled) {
            return <a onClick={onDetailsRequested}>View details</a>;
        }

        if (template.HasUpdate) {
            return <a onClick={onUpdateRequested}>Update available</a>;
        }

        return "";
    }

    var templateDescriptionHtml = {__html: formatText(props.template.Description, 76, true)};

    return <li className="step-template animated" onClick={props.template.IsInstalled ? props.onAdditionRequested : props.onInstallationRequested}>
        <StepTemplateLogo class="logo" size="medium" url={props.template.Links.Logo} resolveLink={props.resolveLink} enableCacheBreaker={false} />

        <div className="name">
            {formatText(props.template.Name, 36)}
        </div>
        <div className="description" dangerouslySetInnerHTML={templateDescriptionHtml}>
        </div>
        <div className={"template-status " + getStatusClass(props.template)}>
            <span>{getStatusText(props.template)}</span>
            {getStatusLogo(props.template)}
        </div>
        <div className="add-action">
            {getAddAction(props.template, props.onAdditionRequested, props.onInstallationRequested)}
            <div className={"add-action-details " + getAddActionDetailsClass(props.template)}>
                {getAddActionDetailsContent(props.template, props.onDetailsRequested, props.onUpdateRequested)}
            </div>
        </div>
    </li>;
};

var StepTemplateCategory = React.createClass({
    propTypes: {
        name: React.PropTypes.string.isRequired,
        templates: React.PropTypes.array.isRequired,
        resolveLink: React.PropTypes.func.isRequired,
        onCategorySelected: React.PropTypes.func.isRequired,
    },
    render: function() {

        var firstTemplate = this.props.templates[0];

        return <li className="step-category animated" onClick={this.props.onCategorySelected}>
            <StepTemplateLogo size="medium" url={firstTemplate.Links.Logo} resolveLink={this.props.resolveLink} enableCacheBreaker={false} />

            <div className="category-name">
                {this.props.name}
            </div>
        </li>;
    }
});


var StepTemplates = React.createClass({
    propTypes: {
        templates: React.PropTypes.array.isRequired,
        onAdditionRequested: React.PropTypes.func.isRequired,
        addButtonName: React.PropTypes.string,
        onInstallationRequested: React.PropTypes.func.isRequired,
        installButtonName: React.PropTypes.string,
        onUpdateRequested: React.PropTypes.func.isRequired,
        onDetailsRequested: React.PropTypes.func.isRequired,
        resolveLink: React.PropTypes.func.isRequired,
        enableGrouping: React.PropTypes.bool
    },
    categoriseTemplates: function(templates){
        var categorised = _.groupBy(templates, t => { return t.Category; });
        return _.keys(categorised).sort(function(category1, cateogry2) { return category1.toLowerCase().localeCompare(cateogry2.toLowerCase()); }).map(categoryName => { return {name: categoryName, templates : categorised[categoryName]};});
    },
    getInitialState: function() {
        return {
            showModal: false,
            templateId: '',
            templateName: '',
            categoryTemplates: [],
            categories: this.categoriseTemplates(this.props.templates)
        };
    },
    popupConfirmation: function(templateId, templateName) {
        this.setState({ templateId: templateId });
        this.setState({ templateName: templateName });
        this.setState({ showModal: true });
    },
    showDetails: function() {
        this.props.onDetailsRequested(this.state.templateId);
    },
    installStepAndAdd: function() {
        this.props.onInstallationRequested(this.state.templateId).then(this.close(), this.close());
    },
    close: function() {
        this.setState({ showModal: false });
    },
    showCategoryTemplates: function(templates) {
        // We are setting min-hight here to avoid "screen jumping" when the user switches from categories to templates.
        // Ideally this would be handled by a CSS transform but it did not work.
        this.categoryTemplatesElement.style.minHeight = this.categoriesElement.clientHeight + "px";
        this.setState({categoryTemplates: templates, categories: []});

    },
    showCategories: function() {
        this.setState({categoryTemplates: [], categories: this.categoriseTemplates(this.props.templates)});
    },
    showAllTemplates: function() {
        this.setState({categoryTemplates: this.props.templates, categories: []});
    },
    componentWillReceiveProps: function(nextProps){
        this.setState({categories: this.categoriseTemplates(nextProps.templates)});
    },
    isInCategoryMode: function(){
        return this.state.categoryTemplates.length === 0 && this.state.categories.length > 0;
    },
    isInCategoryTemplatesMode: function(){
        return this.state.categoryTemplates.length > 0 && this.state.categories.length === 0;
    },
    render: function() {
        return <div>
            { this.props.enableGrouping ?
                <div>
                    {this.isInCategoryMode() && <button className="btn btn-link pull-right" onClick={this.showAllTemplates}>Show all</button>}
                    {this.isInCategoryTemplatesMode() && <button className="btn btn-link pull-right" onClick={this.showCategories}>Back</button>}
                    <div className="grouping-container">
                        <ol className="categories" ref={(element) => this.categoriesElement = element}  >
                            <ReactCSSTransitionGroup
                                transitionName={{enter: 'zoomIn', leave: 'zoomOut' }}
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}>
                                {this.state.categories.map(category => {
                                    return <StepTemplateCategory key={category.name} name={category.name} templates={category.templates}
                                                                 resolveLink={this.props.resolveLink}
                                                                 onCategorySelected={() => this.showCategoryTemplates(category.templates)}/>;
                                })}
                            </ReactCSSTransitionGroup>
                        </ol>
                        <ol className="category-templates" ref={(element) => this.categoryTemplatesElement = element}>
                            <ReactCSSTransitionGroup
                                transitionName={{enter: 'fadeIn', leave: 'fadeOut'}}
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}
                            >
                                {this.state.categoryTemplates.map(template => {
                                    return <StepTemplate key={template.key} template={template}
                                                         onAdditionRequested={() => this.props.onAdditionRequested(template.Type, template.Id)}
                                                         addButtonName={this.props.addButtonName}
                                                         onInstallationRequested={() => this.popupConfirmation(template.Id, template.Name)}
                                                         installButtonName={this.props.installButtonName}
                                                         onUpdateRequested={() => this.props.onUpdateRequested(template.CommunityActionTemplateId)}
                                                         onDetailsRequested={() => this.props.onDetailsRequested(template.Id)}
                                                         resolveLink={this.props.resolveLink}/>;
                                })}
                            </ReactCSSTransitionGroup>
                        </ol>
                    </div>
                </div>
                 :
                <ol>
                    {this.props.templates.map(template => {
                        return <StepTemplate key={template.key} template={template}
                                             onAdditionRequested={() => this.props.onAdditionRequested(template.Type, template.Id)} addButtonName={this.props.addButtonName}
                                             onInstallationRequested={() => this.popupConfirmation(template.Id, template.Name)} installButtonName={this.props.installButtonName}
                                             onUpdateRequested ={() => this.props.onUpdateRequested(template.CommunityActionTemplateId)}
                                             onDetailsRequested={() => this.props.onDetailsRequested(template.Id)}
                                             resolveLink={this.props.resolveLink}/>;
                    })}
                </ol>
            }
            <Modal show={this.state.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <h3>{this.props.installButtonName ? this.props.installButtonName : 'Install and add step'}</h3>
                </Modal.Header>
                <Modal.Body>
                    <h4>{this.state.templateName}</h4>
                    <div className="alert alert-info margin margin-top-10" role="alert">This is a community contributed step that will be installed into your <a className="alert-link" href="#/library/steptemplates">Step templates</a> library. Read our <a className="alert-link" href="http://g.octopushq.com/CommunityContributedStepTemplates" target="_blank">community step documentation</a> for more information.</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-link pull-left" onClick={this.showDetails}>View details</button>
                    <Button onClick={this.close}>Cancel</Button>
                    <Button className="btn btn-success" onClick={this.installStepAndAdd}>{this.props.installButtonName ? this.props.installButtonName : 'Install and add'}</Button>
                </Modal.Footer>
            </Modal>
        </div>;
    }
});

module.directive('stepTemplates', function (reactDirective) {
    return reactDirective(StepTemplates);
});






// WEBPACK FOOTER //
// ./app/areas/projects/step-templates/step_templates.jsx